<template>
  <div class="cadfm-container-horizontal">

            <LibraryTable v-show="$route.params.view == 'LibraryTable'" 
             :lang="lang.LibraryManager.LibraryTable"></LibraryTable>
            <LibraryNew v-if="$route.params.view == 'LibraryNew'" 
            :lang="lang.LibraryManager.LibraryNew"></LibraryNew>
            <LibraryDetails v-if="$route.params.view == 'LibraryDetails'" 
            :lang="lang.LibraryManager.LibraryDetails"></LibraryDetails>
            <LibraryDerive v-if="$route.params.view == 'LibraryDerive'" 
            :lang="lang.LibraryManager.LibraryDerive"></LibraryDerive>
            <Categories v-if="$route.params.view == 'Categories'"
             :lang="lang.LibraryManager.Categories"></Categories>
            <Properties v-if="$route.params.view == 'Properties'"
             :lang="lang.LibraryManager.Properties"></Properties>
 </div>
</template>

<script>
import LibraryTable from '@/components/LibraryManager/Views/LibraryTable'
import LibraryNew from '@/components/LibraryManager/Views/LibraryNew'
import LibraryDetails from '@/components/LibraryManager/Views/LibraryDetails'
import LibraryDerive from '@/components/LibraryManager/Views/LibraryDerive'
import Categories from '@/components/LibraryManager/Views/Categories'
import Properties from '@/components/LibraryManager/Views/Properties'

//import Left from '@/components/PartManager/Left/Left'
//import Right from '@/components/PartManager/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'LibraryManager',
  components:{
    LibraryTable,
    LibraryNew,
    LibraryDetails,
    LibraryDerive,
    Categories,
    Properties
  },
  props: {
    lang: Object
  },
  data () {
    return {
      sectionPrefix: "lm",
      basicView: "LibraryTable",
    }
  },
  computed: {
    
    
  },
  beforeCreate () {
    
    
    this.$store.dispatch("setView", "LibraryTable");
  },
  created() {
    this.$store.dispatch("showLoader", { visible: false, text: "" });
    this.$store.dispatch("setSectionPrefix", this.sectionPrefix)
  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/LibraryManager.vue